import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const FilteredAndSortedAscendingIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path stroke="currentColor" d="M11 12.5h9M12 15.5h6M13 18.5h4M5 7l3.5-2L12 7M8.5 5v11" />
        </svg>
    </IconWrapper>
)
